export default "__VITE_ASSET__DoaYRX5N__"